import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderTitle } from '../../../components/molecues';

class VideoCognitionGrammar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 9,

        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickHome = () => {
        this.props.history.replace('/cognitiongrammar');
    }
    render() {
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
            
        };
        const ctgFileName = "https://ecprime-web.s3.ap-northeast-1.amazonaws.com/video/cognitiongrammar/" + this.props.ctgFileName + ".mp4";
        return(
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <video 
                    width="100%"
                    height="100%"
                    autoPlay 
                    controls 
                    controlsList="nodownload"
                    disablePictureInPicture 
                    onContextMenu={e=> e.preventDefault()}
                >
                    <source src={ctgFileName} type="video/mp4" />                    
                </video>
            </Body>
        );
    }
}
const mapStateToProps = store => {
    return {
        ctgFileName: store.video.ctgFileName,
    }
};

const connectedVideoCognitionGrammar = connect(mapStateToProps)(VideoCognitionGrammar);
export { connectedVideoCognitionGrammar as VideoCognitionGrammar };

const Body = styled.div`
    video {
        user-select: none;
        max-width: 1024px;
        text-align: center;
        display: block;
        margin: auto;
    }
`;